"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TmsFuelLevelSchema = void 0;
const zod_1 = require("zod");
exports.TmsFuelLevelSchema = zod_1.z.object({
    fuelLevelPercent: zod_1.z.number().min(0).max(100),
    dataTimestamp: zod_1.z.string().datetime(),
});
//# sourceMappingURL=fuelLevel.js.map